import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router"
import { Route } from '../../interfaces/route';
import { StatusService } from '../../services/status.service';
import { RouteService } from '../../services/route.service';

const recent_routes_max_length = 2;

@Component({
  selector: 'app-schedule-routes',
  templateUrl: './schedule-routes.component.html',
  styleUrls: ['./schedule-routes.component.css']
})
export class ScheduleRoutesComponent implements OnInit {
  public realtime: boolean = true;
  public statuses: Route[] = []
  public routes: Route[] = [];
  public all_routes: Route[] = [];
  public mode: string = '';

  public selected_route: string;
  public screen: any;

  public recent_routes: any = [];
  public recent_routes_status: any = [];
  constructor(private statusService: StatusService, private routeService: RouteService, private route: ActivatedRoute) {
    var recent_routes = localStorage.getItem("recent_routes");

    if (recent_routes != null) {

      if (Array.isArray(JSON.parse(recent_routes)) === true) {
        this.recent_routes = JSON.parse(recent_routes);
      }
      else {
        this.recent_routes.push(recent_routes)
      }

      this.routeService.get()
        .subscribe(routes => {
          this.all_routes = routes;
        });
    }

    this.routeService.getStaticRoute("1");
  }

  ngOnInit(): void {

    this.mode = this.route.snapshot.paramMap.get('mode');
    if (!['rail', 'subway', 'nhsl', 'other', 'trolley', 'cct'].includes(this.mode)) {
      this.mode = 'bus';
    }

    //this.routes = this.routeService.routes;
    this.getRoutes();


    this.screen = window.innerWidth;
  }

  getRoutes(): void {
    this.statusService.get()
      .subscribe(statuses => {
        this.statuses = statuses;
        this.realtime = this.statusService.realtime;
      });
  }

  selectRoute(selected_route: string): void {
    this.selected_route = selected_route;

    //Check if newly selected route is in the recent selected routes, if not add it...
    if (this.recent_routes.find((x: string) => x == selected_route) == undefined) {
      this.recent_routes.push(selected_route);

      //Check if recent routes is larger than set limit
      console.log(this.recent_routes.length);
      if (this.recent_routes.length > recent_routes_max_length) {
        this.recent_routes.shift();
      }

      localStorage.setItem("recent_routes", JSON.stringify(this.recent_routes));
    }
  }


}
